/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiProjectMerchant;
(function (ApiProjectMerchant) {
    ApiProjectMerchant["UNSPECIFIED"] = "MERCHANT_UNSPECIFIED";
    ApiProjectMerchant["STRIPE"] = "MERCHANT_STRIPE";
    ApiProjectMerchant["SHOPIFY"] = "MERCHANT_SHOPIFY";
})(ApiProjectMerchant || (ApiProjectMerchant = {}));
export function ApiProjectMerchantFromJSON(json) {
    return ApiProjectMerchantFromJSONTyped(json, false);
}
export function ApiProjectMerchantFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiProjectMerchantToJSON(value) {
    return value;
}
